import type { createPaymentOperatorInput } from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface KeyTypes {
	useListPaymentOperators: undefined;
	useCreatePaymentOperator: createPaymentOperatorInput;
}

const PAYMENT_OPERATORS_SERVICE_KEYS = createReactQueryKeys<KeyTypes>(
	"payment_operators",
	["useListPaymentOperators", "useCreatePaymentOperator"],
);

export { PAYMENT_OPERATORS_SERVICE_KEYS };
